<template>
	<div class="users-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">后台账号管理</h1>
						<p class="page-description">系统后台登录账号的管理与维护</p>
					</div>
					<div class="header-actions">
						<el-button 
							type="primary" 
							icon="el-icon-plus" 
							@click="addOrUpdateHandler()" 
							class="add-btn"
						>
							新增账号
						</el-button>
					</div>
				</div>
			</div>

			<!-- 搜索和筛选区域 -->
			<div class="filter-section">
				<el-card class="filter-card" shadow="never">
					<div class="filter-content">
						<el-form :inline="true" :model="searchForm" class="search-form">
							<div class="filter-row">
								<div class="filter-group">
									<label class="filter-label">用户名</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.username" 
											placeholder="请输入用户名" 
											clearable
											prefix-icon="el-icon-user"
											class="search-input"
										></el-input>
									</div>
								</div>
								
								<div class="filter-actions">
									<el-button 
										type="primary" 
										icon="el-icon-search" 
										@click="search()"
										class="search-btn"
									>
										查询
									</el-button>
									<el-button 
										icon="el-icon-refresh" 
										@click="resetSearch()"
										class="reset-btn"
									>
										重置
									</el-button>
								</div>
							</div>
						</el-form>
					</div>
				</el-card>
			</div>

			<!-- 操作栏 -->
			<div class="toolbar-section" v-if="dataListSelections.length > 0">
				<el-card class="toolbar-card" shadow="never">
					<div class="toolbar-content">
						<div class="selection-info">
							<i class="el-icon-info"></i>
							<span>已选择 <strong>{{ dataListSelections.length }}</strong> 项</span>
							<span v-if="adminSelectedCount > 0" class="admin-warning">
								（含 <strong>{{ adminSelectedCount }}</strong> 个管理员账号，将跳过删除）
							</span>
						</div>
						<div class="batch-actions">
							<el-button 
								v-if="isAuth('users','删除')" 
								type="danger" 
								icon="el-icon-delete" 
								@click="deleteHandler()"
								:disabled="deletableSelections.length <= 0"
								class="batch-delete-btn"
							>
								批量删除 ({{ deletableSelections.length }})
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card class="table-card" shadow="never">
					<el-table 
						class="data-table"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无数据"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						
						<el-table-column 
							prop="username"
							label="用户名"
							min-width="150"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="user-info">
									<div class="user-avatar">
										<svg viewBox="0 0 24 24">
											<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
										</svg>
									</div>
									<span class="username">{{ scope.row.username }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="password"
							label="密码"
							min-width="120"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="password-field">
									<span class="password-mask">{{ '●'.repeat(Math.min(scope.row.password.length, 8)) }}</span>
									<el-tooltip content="点击查看密码" placement="top">
										<el-button 
											type="text" 
											icon="el-icon-view" 
											@click="showPassword(scope.row)"
											class="view-password-btn"
										></el-button>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="role"
							label="角色"
							width="120"
							align="center"
						>
							<template slot-scope="scope">
								<el-tag 
									:type="getRoleTagType(scope.row.role)"
									class="role-tag"
								>
									<i :class="getRoleIcon(scope.row.role)"></i>
									{{ scope.row.role || '未设置' }}
								</el-tag>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="status"
							label="状态"
							width="100"
							align="center"
						>
							<template slot-scope="scope">
								<el-switch
									v-model="scope.row.status"
									active-text="启用"
									inactive-text="禁用"
									active-value="启用"
									inactive-value="禁用"
									:disabled="scope.row.role === '管理员'"
									@change="toggleStatus(scope.row)"
									class="status-switch"
								>
								</el-switch>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="addtime"
							label="创建时间"
							width="180"
							align="center"
						>
							<template slot-scope="scope">
								<div class="time-info">
									<i class="el-icon-time"></i>
									<span>{{ formatTime(scope.row.addtime) }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="220" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="scope.row.role !== '管理员'" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>
									<el-button 
										v-if="scope.row.role !== '管理员'" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
									<!-- 管理员保护提示 -->
									<el-tooltip 
										v-if="scope.row.role === '管理员'" 
										content="管理员账号受保护，无法修改或删除" 
										placement="top"
									>
										<el-button 
											type="info" 
											size="mini" 
											icon="el-icon-lock"
											disabled
											class="action-btn protected-btn"
										>
											受保护
										</el-button>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
		
		<!-- 密码查看对话框 -->
		<el-dialog 
			title="查看密码" 
			:visible.sync="passwordDialogVisible" 
			width="400px"
			:before-close="handlePasswordDialogClose"
		>
			<div class="password-dialog">
				<div class="password-info">
					<div class="info-row">
						<label>用户名：</label>
						<span>{{ selectedUser.username }}</span>
					</div>
					<div class="info-row">
						<label>密码：</label>
						<span class="password-text">{{ selectedUser.password }}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="passwordDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        username: ''
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],
      passwordDialogVisible: false,
      selectedUser: {}
    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  computed: {
    // 计算可删除的选择项（排除管理员）
    deletableSelections() {
      return this.dataListSelections.filter(item => item.role !== '管理员');
    },
    
    // 计算选中的管理员数量
    adminSelectedCount() {
      return this.dataListSelections.filter(item => item.role === '管理员').length;
    }
  },
  methods: {
    contentStyleChange() {
      this.contentPageStyleChange()
    },
    
    contentPageStyleChange(){
      let arr = []
    },

    init () {
    },

    // 获取表格索引
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        username: ''
      };
      this.search();
    },

    // 获取角色标签类型
    getRoleTagType(role) {
      if (role === '管理员') return 'danger';
      if (role === '操作员') return 'success';
      return 'info';
    },

    // 获取角色图标
    getRoleIcon(role) {
      if (role === '管理员') return 'el-icon-user-solid';
      if (role === '操作员') return 'el-icon-user';
      return 'el-icon-question';
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      if (status === '禁用') return 'danger';
      return 'success';
    },

    // 获取状态图标
    getStatusIcon(status) {
      if (status === '禁用') return 'el-icon-close';
      return 'el-icon-check';
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '未知';
      return new Date(time).toLocaleString('zh-CN');
    },

    // 显示密码
    showPassword(user) {
      this.selectedUser = user;
      this.passwordDialogVisible = true;
    },

    // 处理密码对话框关闭
    handlePasswordDialogClose() {
      this.selectedUser = {};
      this.passwordDialogVisible = false;
    },

    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
           if(this.searchForm.username!='' && this.searchForm.username!=undefined){
            params['username'] = '%' + this.searchForm.username + '%'
          }
      this.$http({
        url: "users/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      // 单个删除时，检查是否为管理员
      if (id) {
        const targetUser = this.dataList.find(item => item.id == id);
        if (targetUser && targetUser.role === '管理员') {
          this.$message.warning('管理员账号受保护，无法删除！');
          return;
        }
      }
      
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      
      // 批量删除时，过滤掉管理员账号
      if (!id) {
        const deletableIds = this.dataListSelections
          .filter(item => item.role !== '管理员')
          .map(item => Number(item.id));
        
        if (deletableIds.length === 0) {
          this.$message.warning('选中的账号都是管理员，无法删除！');
          return;
        }
        
        if (this.adminSelectedCount > 0) {
          this.$message.info(`将跳过 ${this.adminSelectedCount} 个管理员账号，仅删除 ${deletableIds.length} 个普通账号。`);
        }
        
        ids = deletableIds;
      }
      
      const deleteCount = ids.length;
      const actionText = id ? "删除" : `批量删除 ${deleteCount} 个账号`;
      
      this.$confirm(`确定进行[${actionText}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "users/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    
    // 切换账号状态
    toggleStatus(row) {
      // 如果是管理员，阻止切换并恢复原状态
      if (row.role === '管理员') {
        this.$message.warning('管理员账号状态不能修改');
        // 恢复原状态
        this.$nextTick(() => {
          row.status = '启用';
        });
        return;
      }
      
      const status = row.status;
      this.$confirm(`确定要${status}账号 "${row.username}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: "users/updateStatus",
          method: "post",
          data: {
            id: row.id,
            status: status
          }
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: `账号 "${row.username}" 已${status}`,
              type: 'success',
              duration: 1500
            });
          } else {
            this.$message.error(data.msg);
            // 如果后端更新失败，恢复原状态
            this.$nextTick(() => {
              row.status = status === '启用' ? '禁用' : '启用';
            });
          }
        }).catch(() => {
          // 请求失败时恢复原状态
          this.$nextTick(() => {
            row.status = status === '启用' ? '禁用' : '启用';
          });
        });
      }).catch(() => {
        // 用户取消时恢复原状态
        this.$nextTick(() => {
          row.status = status === '启用' ? '禁用' : '启用';
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.users-list-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;
			margin-left: 16px;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}

		.header-actions {
			.add-btn {
				padding: 12px 24px;
				font-weight: 500;
				border-radius: 8px;
				background: linear-gradient(135deg, #10b981 0%, #059669 100%);
				border: none;
				
				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
				}
			}
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 24px;

	.filter-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 24px;
		}
	}

	.filter-content {
		.search-form {
			margin: 0;

			.filter-row {
				display: flex;
				align-items: flex-end;
				gap: 20px;
				flex-wrap: wrap;
			}

			.filter-group {
				display: flex;
				flex-direction: column;
				min-width: 200px;

				.filter-label {
					font-size: 14px;
					font-weight: 500;
					color: #374151;
					margin-bottom: 8px;
				}

				.filter-input {
					.search-input {
						width: 200px;
					}
				}
			}

			.filter-actions {
				display: flex;
				gap: 12px;
				margin-left: auto;

				.el-button {
					padding: 10px 20px;
					font-weight: 500;
					border-radius: 6px;
				}

				.search-btn {
					background: #3b82f6;
					border-color: #3b82f6;
				}

				.reset-btn {
					color: #6b7280;
					border-color: #d1d5db;

					&:hover {
						color: #374151;
						border-color: #9ca3af;
					}
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 16px;

	.toolbar-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 16px 24px;
		}
	}

	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.selection-info {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #3b82f6;
			font-size: 14px;

			i {
				font-size: 16px;
			}

			strong {
				color: #1d4ed8;
			}

			.admin-warning {
				color: #f56c6c;
				font-size: 13px;
				margin-left: 10px;
				font-weight: 500;

				strong {
					color: #dc2626;
				}
			}
		}

		.batch-actions {
			.batch-delete-btn {
				padding: 8px 16px;
				font-size: 13px;
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 24px;

	.table-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.data-table {
		:deep(.el-table__header) {
			th {
				background: #f8fafc;
				color: #374151;
				font-weight: 600;
				border-bottom: 1px solid #e5e7eb;
				padding: 16px 0;

				.cell {
					padding: 0 16px;
				}
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f8fafc;
				}

				td {
					border-bottom: 1px solid #f1f5f9;
					padding: 16px 0;

					.cell {
						padding: 0 16px;
					}
				}
			}
		}

		// 用户信息
		.user-info {
			display: flex;
			align-items: center;
			gap: 12px;

			.user-avatar {
				width: 40px;
				height: 40px;
				background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;

				svg {
					width: 20px;
					height: 20px;
					fill: white;
				}
			}

			.username {
				font-weight: 500;
				color: #374151;
			}
		}

		// 密码字段
		.password-field {
			display: flex;
			align-items: center;
			gap: 8px;

			.password-mask {
				font-family: monospace;
				letter-spacing: 2px;
				color: #6b7280;
			}

			.view-password-btn {
				padding: 4px;
				color: #3b82f6;

				&:hover {
					background: #eff6ff;
				}
			}
		}

		// 角色标签
		.role-tag {
			i {
				margin-right: 4px;
			}
		}

		// 状态标签
		.status-tag {
			i {
				margin-right: 4px;
			}
		}

		// 状态开关
		.status-switch {
			:deep(.el-switch__label) {
				position: absolute;
				font-size: 12px;
				font-weight: 500;
			}

			:deep(.el-switch__label.el-switch__label--left) {
				right: 60px;
				color: #f56c6c;
			}

			:deep(.el-switch__label.el-switch__label--right) {
				left: 60px;
				color: #67c23a;
			}

			:deep(.el-switch__core) {
				width: 50px;
				height: 24px;
				border-radius: 12px;
				
				&::before {
					width: 20px;
					height: 20px;
				}
			}

			:deep(.el-switch.is-checked .el-switch__core) {
				background-color: #67c23a;
				border-color: #67c23a;
			}

			:deep(.el-switch.is-disabled) {
				opacity: 0.6;
			}
		}

		// 时间信息
		.time-info {
			display: flex;
			align-items: center;
			gap: 6px;
			color: #6b7280;
			font-size: 13px;

			i {
				color: #9ca3af;
			}
		}

		// 操作按钮
		.action-buttons {
			display: flex;
			gap: 6px;
			justify-content: center;
			align-items: center;

			.action-btn {
				padding: 4px 8px;
				font-size: 12px;
				border-radius: 4px;
				min-width: auto;
				white-space: nowrap;

				&.view-btn {
					background: #6b7280;
					border-color: #6b7280;
					color: white;

					&:hover {
						background: #4b5563;
						border-color: #4b5563;
					}
				}

				&.edit-btn {
					background: #3b82f6;
					border-color: #3b82f6;

					&:hover {
						background: #2563eb;
						border-color: #2563eb;
					}
				}

				&.delete-btn {
					background: #ef4444;
					border-color: #ef4444;

					&:hover {
						background: #dc2626;
						border-color: #dc2626;
					}
				}

				&.protected-btn {
					background: #f3f4f6;
					border-color: #d1d5db;
					color: #6b7280;
					cursor: not-allowed;

					&:hover {
						background: #f3f4f6;
						border-color: #d1d5db;
						color: #6b7280;
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;

	.data-pagination {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}

// 密码查看对话框
.password-dialog {
	.password-info {
		.info-row {
			display: flex;
			align-items: center;
			margin-bottom: 16px;
			
			&:last-child {
				margin-bottom: 0;
			}

			label {
				width: 80px;
				font-weight: 500;
				color: #374151;
			}

			span {
				color: #6b7280;
			}

			.password-text {
				font-family: monospace;
				background: #f3f4f6;
				padding: 8px 12px;
				border-radius: 4px;
				border: 1px solid #d1d5db;
				font-size: 14px;
				color: #374151;
				word-break: break-all;
			}
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.users-list-container {
		padding: 20px;
	}

	.filter-section {
		.filter-content {
			.search-form {
				.filter-row {
					flex-direction: column;
					align-items: stretch;
					gap: 16px;
				}

				.filter-group {
					min-width: auto;

					.filter-input {
						.search-input {
							width: 100%;
						}
					}
				}

				.filter-actions {
					margin-left: 0;
					justify-content: center;

					.el-button {
						flex: 1;
						max-width: 120px;
					}
				}
			}
		}
	}

	.table-section {
		.data-table {
			:deep(.el-table__body) {
				tr td {
					padding: 12px 0;

					.cell {
						padding: 0 8px;
					}
				}
			}

			.action-buttons {
				flex-direction: column;
				gap: 4px;

				.action-btn {
					width: 100%;
					max-width: 60px;
					padding: 4px 8px;
					font-size: 11px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.users-list-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			text-align: center;

			.header-text {
				margin-left: 0;

				.page-title {
					font-size: 20px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-content {
			flex-direction: column;
			gap: 12px;
			text-align: center;
		}
	}

	.table-section {
		// 移动端表格可能需要横向滚动
		overflow-x: auto;

		.table-card {
			:deep(.el-card__body) {
				padding: 0;
			}
		}

		.data-table {
			min-width: 600px;

			.user-info {
				.user-avatar {
					width: 32px;
					height: 32px;

					svg {
						width: 16px;
						height: 16px;
					}
				}
			}

			.action-buttons {
				.action-btn {
					padding: 4px 6px;
					font-size: 10px;
					min-width: 44px;
				}
			}
		}
	}

	.pagination-section {
		.data-pagination {
			padding: 16px;
			
			:deep(.el-pagination) {
				.el-pagination__total,
				.el-pagination__jump {
					display: none;
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.users-list-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 18px;
				}

				.page-description {
					font-size: 13px;
				}
			}

			.header-actions {
				.add-btn {
					padding: 10px 16px;
					font-size: 13px;
				}
			}
		}
	}

	.filter-section {
		.filter-card {
			:deep(.el-card__body) {
				padding: 16px;
			}
		}
	}
}
</style>
